import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  filter, values, indexOf,
  delay, each, map, find, reduce,
} from 'lodash';
import { AgGridReact } from 'ag-grid-react';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import SearchField from '../../../../components/search-field';

function GroupRowInnerRenderer(props) {
  return (
    <strong className="text-uppercase">{props.value}</strong>
  );
}
GroupRowInnerRenderer.propTypes = {
  value: PropTypes.string,
};
GroupRowInnerRenderer.defaultProps = {
  value: null,
};

function NameRenderer(props) {
  const {
    submitted, value, disabledWhenSubmitted, data,
  } = props;
  if (submitted) {
    const tip = (
      <Tooltip id={`${data.contact_id}_tooltip`}>This contact has been submitted</Tooltip>
    );
    const preIcon = disabledWhenSubmitted ? (<span><OverlayTrigger placement="right" overlay={tip}><Fa name="check-square" className="text-muted" /></OverlayTrigger>&nbsp;&nbsp;&nbsp;</span>) : null;
    const postIcon = disabledWhenSubmitted ? null : (<span>&nbsp;<OverlayTrigger placement="right" overlay={tip}><Fa name="check-circle" className="text-success" /></OverlayTrigger></span>);
    return (
      <span>{preIcon}{value}{postIcon}</span>
    );
  }
  return (
    <span>{value}</span>
  );
}
NameRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    contact_id: PropTypes.string,
  }),
  submitted: PropTypes.bool,
  disabledWhenSubmitted: PropTypes.bool,
};
NameRenderer.defaultProps = {
  value: null,
  submitted: false,
  data: null,
  disabledWhenSubmitted: false,
};


class ContactList extends Component {
  constructor(props) {
    super(props);
    let showAccountContacts = false;

    if (props.selectedContacts && props.selectedContacts.length) {
      const selectedAccountContacts = filter(props.selectedContacts, { isOpportunityContact: false });
      if (selectedAccountContacts.length > 0) {
        showAccountContacts = true;
      } else if (props.opportunityContacts && props.opportunityContacts.length === 0) {
        showAccountContacts = true;
      } 
    } else if (props.opportunityContacts && props.opportunityContacts.length === 0) {
      showAccountContacts = true;
    }

    this.state = {
      showAccountContacts,
      currentContactId: null,
    };

    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.getCheckboxSelection = this.getCheckboxSelection.bind(this);
    this.getRowStyle = this.getRowStyle.bind(this);
    this.nameCellRendererSelector = this.nameCellRendererSelector.bind(this);
    this.actionValueGetter = this.actionValueGetter.bind(this);
    this.getActionCellStyle = this.getActionCellStyle.bind(this);
    this.onActionCellClicked = this.onActionCellClicked.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const prev = this.props.editingContact || {};
    const next = nextProps.editingContact || {};
    if ((!next || !next.contact_id) && next.contact_id !== prev.contact_id) {
      delay(() => {
        this.onInitSelectedContacts(true);
      }, 1);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.onFirstDataRendered();
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { width } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        this.onInitSelectedContacts();
        this.gridApi.hideOverlay();
      }, 500);
    }
  }

  onInitSelectedContacts(redraw = false) {
    if (this.gridApi) {
      const { selectedContacts } = this.props;
      const { currentContactId } = this.state;
      let contactNode = null;
      this.gridApi.forEachNode((node) => {
        const nodeData = node.data;
        if (nodeData) {
          const selected = find(selectedContacts, { contact_id: nodeData.contact_id }) !== undefined;

          if (nodeData.contact_id === currentContactId) {
            contactNode = node;
          }
          node.setSelected(selected);
        } else {
          node.setSelected(false);
        }
      });
      if (redraw) {
        if (contactNode) {
          this.gridApi.refreshCells({ rowNodes: [contactNode], force: true });
          this.gridApi.ensureIndexVisible(contactNode.rowIndex, 'top');
        } else {
          this.gridApi.redrawRows({ force: true });
        }
      }
    }
  }

  onSelectionChanged() {
    if (this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      const contacts = reduce(selectedRows, (items, data) => {
        if (this.getCheckboxSelection({ data })) {
          items.push(data);
        }
        return items;
      }, []);
      this.props.onSelectContacts(contacts);
      this.gridApi.redrawRows({ force: true });
    }
  }

  onActionCellClicked(params) {
    if (!params || !params.data) {
      return false;
    }
    const selected = params.node && params.node.selected;
    if (selected) {
      this.setState({ currentContactId: params.data.contact_id });
      this.props.onEditContact(params.data);
    }
  }

  getCheckboxSelection(params) {
    if (!params || !params.data) {
      return false;
    }
    if (!this.props.disabledWhenSubmitted) {
      return true;
    }
    const submitted = this.getSubmmitted(params);
    return !submitted;
  }

  getSubmmitted(params) {
    return indexOf(this.props.submittedContactIds, params.data.contact_id) >= 0;
  }
  getRowStyle(params) {
    if (!params || !params.data) {
      return false;
    }
    const selected = params.node && params.node.selected;
    if (selected) {
      return null;
    }
    const submitted = this.getSubmmitted(params);
    if (!submitted) {
      return {};
    }
    return {
      background: '#efefef',
    };
  }

  getActionCellStyle(params) {
    if (!params || !params.node) {
      return null;
    }
    const { selected } = params.node;
    if (selected) {
      return {
        cursor: 'pointer',
      };
    }
    return null;
  }

  actionValueGetter(params) {
    if (!params || !params.node) {
      return null;
    }
    const { selected } = params.node;
    if (selected) {
      return 'Edit';
    }
    return null;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  nameCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    return {
      params: {
        submitted: this.getSubmmitted(params),
        disabledWhenSubmitted: this.props.disabledWhenSubmitted,
      },
      component: NameRenderer,
    };
  }

  render() {
    const {
      width, opportunityContacts, account,
      isActive,
    } = this.props;

    if (!isActive) {
      return null;
    }

    const accountContacts = account ? account.contacts || [] : [];

    const indexedOpportunityContacts = reduce(opportunityContacts, (items, c) => {
      items[c.contact_id] = {
        ...c,
        contact_type: 'Opportunity Contacts',
      };
      return items;
    }, {});

    const indexedAccountContacts = reduce(accountContacts, (items, c) => {
      items[c.contact_id] = {
        ...c,
        contact_type: 'Account Contacts',
      };
      return items;
    }, {});
  
    const availableContacts = values({ ...indexedAccountContacts, ...indexedOpportunityContacts });

    const rowHeight = 34;
    const tableHeight = Math.min(400, (rowHeight * availableContacts.length) + rowHeight + 2 + ((rowHeight * 2)));

    const columnDefs = [
      {
        headerName: 'Type',
        colId: 'TYPE',
        field: 'contact_type',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        hide: true,
        rowGroup: true,
        rowGroupIndex: 0,
      },
      {
        headerName: 'Contact',
        colId: 'CONTACT',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        checkboxSelection: this.getCheckboxSelection,
        headerCheckboxSelection: true,
        cellStyle: { paddingLeft: '30px' },
        pinned: 'left',
        valueGetter: (params) => {
          if (!params || !params.data) {
            return null;
          }
          return `${params.data.first_name} ${params.data.last_name}`;
        },
        cellRendererSelector: this.nameCellRendererSelector,
      },
      {
        headerName: 'Title',
        colId: 'TITLE',
        field: 'title',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 100,
      },
      {
        headerName: 'Action',
        colId: 'ACTION',
        field: 'contact_id',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        sortable: false,
        width: 100,
        pinned: 'right',
        valueGetter: this.actionValueGetter,
        cellClass: 'text-center text-active',
        cellStyle: this.getActionCellStyle,
        onCellClicked: this.onActionCellClicked,
      },
    ];

    return (
      <div>
        {availableContacts.length >= 5 &&
          <nav className="navbar navbar-default navbar-controls">
            <div className="navbar-form navbar-left">
              <SearchField onSearch={this.handleSearch} />
            </div>
          </nav>
        }
        {availableContacts.length > 0 &&
          <div className="ag-theme-alpine" style={{ width, height: tableHeight }}>
            <AgGridReact
              reactNext
              enableColResize
              enableSorting
              animateRows
              suppressColumnVirtualisation
              groupUseEntireRow
              groupDefaultExpanded={-1}
              columnDefs={columnDefs}
              getRowNodeId={({ data }) => data.contact_id}
              onGridReady={this.onGridReady}
              rowData={availableContacts}
              rowSelection="multiple"
              suppressRowClickSelection
              onSelectionChanged={this.onSelectionChanged}
              rowHeight={rowHeight}
              getRowStyle={this.getRowStyle}
              groupDisplayType="groupRows"
              groupRowRendererParams={{
                innerRenderer: GroupRowInnerRenderer,
              }}
            />
          </div>
        }
        {availableContacts.length === 0 &&
          <div className="alert alert-warning">No contacts found</div>
        }
      </div>
    );
  }
}

ContactList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedContacts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  submittedContactIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  opportunityContacts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  account: PropTypes.shape({}),
  width: PropTypes.number.isRequired,
  onSelectContacts: PropTypes.func,
  onEditContact: PropTypes.func,
  disabledWhenSubmitted: PropTypes.bool,
  isActive: PropTypes.bool,
  editingContact: PropTypes.shape({
  }),
};
ContactList.defaultProps = {
  disabledWhenSubmitted: true,
  account: null,
  onSelectContacts: () => {},
  onEditContact: () => {},
  isActive: false,
  editingContact: null,
};
function mapStateToProps() {
  return {};
}
export default connect(mapStateToProps)(ContactList);
